import React, { memo, ComponentType } from 'react'
import classNames from 'classnames'
import { ICommonProps } from 'transfix-ui/components/SvgIcon/types'
import { Box, makeStyles, IBoxProps as MuiBoxProps } from 'transfix-ui/core'
import { brandColors, TBrandColor } from 'transfix-ui/theme'

export type TIconSize = 'large' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge'

export interface IIconWrapperProps {
  /**
   * Color of the icon
   * @example 'skyBlue6'
   * @default 'inherit'
   */
  color?: TBrandColor | 'inherit'
  BoxProps?: MuiBoxProps
  Icon: ComponentType<ICommonProps>
  /**
   * @default 'large'
   */
  size?: TIconSize
  className?: string
}

const useIconWrapperStyles = makeStyles<'root', Pick<IIconWrapperProps, 'color'>>({
  root: {
    color: ({ color = 'inherit' }) => {
      if (color === 'inherit') {
        return color
      }
      return brandColors[color]
    },
  },
})

/**
 * @deprecated Use `<SvgIcon />` instead. It does the same thing!
 * Helper component to easily assign color and size to any Icon component
 */
export const IconWrapper = memo<IIconWrapperProps>(
  ({
    color = 'coolGray5',
    BoxProps = {},
    Icon: IconComponent,
    size = 'large',
    className: classNameProp,
  }) => {
    const wrapperClasses = useIconWrapperStyles({
      color,
    })

    // This uses utility classNames to style <Icon />
    const className = classNames('icon', size)

    return (
      <Box
        data-test='icon-wrapper'
        className={classNames(wrapperClasses.root, classNameProp)}
        {...BoxProps}>
        <IconComponent className={className} />
      </Box>
    )
  }
)

export default IconWrapper
